module.exports = "/_next/static/resources/zoe-mesnik-greene-6fcaed92283e161ab16fa99b012ef10a.jpg";